'use client'

import { useEffect, useRef } from 'react'
import { usePathname } from 'next/navigation'

import { clearUTMParams, isConversionFlowPage } from '~/utils/utm-tracking'

/**
 * Component that listens for navigation changes and clears UTM params
 * when user navigates away from conversion flow
 */
export function UTMCleanupListener() {
  const pathname = usePathname()
  const prevPathnameRef = useRef<string | null>(null)

  useEffect(() => {
    const isCurrentConversionPage = isConversionFlowPage(pathname)
    const wasPrevConversionPage =
      prevPathnameRef.current !== null
        ? isConversionFlowPage(prevPathnameRef.current)
        : false

    // Only clear when transitioning FROM conversion flow TO non-conversion page
    if (wasPrevConversionPage && !isCurrentConversionPage) {
      clearUTMParams()
    }

    prevPathnameRef.current = pathname
  }, [pathname])

  return null
}
